<footer class="sticky-footer">
  <div class="container my-auto">
    <div class="copyright text-center my-auto">
      <!-- <div class="d-none d-lg-block rrssBox">
        <ng-container *ngFor="let rrss of config.SISTEMA.RRSS">
          <i class="{{rrss.icon}} fa-footer" title="{{rrss.title}}" (click)="goRRSS(rrss.url)"></i>
        </ng-container>
      </div> -->
      <div>
        <a href="{{config.UV.URL}}" target="_blank" class="text-white">{{config.UV.NOMBRE}} &reg;</a>
        v{{package.version}}<br>
        <a href="{{config.DTIC.URL}}" target="_blank" class="text-white"
          title="{{config.DTIC.NOMBRE}}">{{config.DTIC.SIGLA}} &copy;</a> {{fecha | date:'yyyy'}}
      </div>
    </div>
  </div>
</footer>